import { render } from "./JsonEditor.vue?vue&type=template&id=b06022ec&scoped=true"
import script from "./JsonEditor.vue?vue&type=script&lang=js"
export * from "./JsonEditor.vue?vue&type=script&lang=js"

import "./JsonEditor.vue?vue&type=style&index=0&id=b06022ec&lang=css"
import "./JsonEditor.vue?vue&type=style&index=1&id=b06022ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b06022ec"]])

export default __exports__